<template>
    <ordering-table-orders
        :page-title="$tl('labels.modules.orderingTable.liveService.title')"
        :page-subtitle="$tl('labels.modules.orderingTable.liveService.subtitle')"
        :status-options-override="statusOptions"
        default-status="all" />
</template>

<script>
import OrderingTableOrders from "../Orders/OrderingTableOrders.vue";

export default {
    components: {
        OrderingTableOrders,
    },
    computed: {
        statusOptions() {
            return [
                { value: "all", label: this.$tl("labels.modules.orderingTable.orders.filters.all") },
                { value: "created", label: this.$tl("labels.modules.orderingTable.orders.status.created") },
                { value: "validated", label: this.$tl("labels.modules.orderingTable.orders.status.validated") },
            ];
        },
    },
};
</script>
